import React from 'react'
// libs
import styled from 'styled-components'
import Tooltip from '@mui/material/Tooltip'
import { useRouter } from 'hooks/useRouter'
// static
import ClockIcon from '@mui/icons-material/AccessTime'
// constants
import { Modals } from 'constants/modals'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// types
import { IField } from 'types/graphql'
// context
import { PublicContext } from 'containers/Risks/Risk/Edit/public'
import { RiskAPIContext } from 'containers/Risks/Risk/Edit/layers/API'
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// themes
import { colors } from 'themes/index'

export const ClockIconButton = styled(ClockIcon)`
  height: 20px;
  width: 20px;
  min-width: 20px;
  cursor: pointer;
  margin-top: 6px;

  path {
    fill: ${colors.blue500};
  }

  &:hover {
    opacity: 0.7;
  }
`

interface Props {
  field: IField
  riskId?: string
  fieldValueId?: string
}

const HistoryButton: React.FC<Props> = ({ field, riskId, fieldValueId }) => {
  const router = useRouter()

  const { showModal } = useShowModal({ modalType: Modals.RISK_FIELD_HISTORY_MODAL })

  const { risk } = React.useContext(RiskAPIContext)
  const { isRisksRegister } = React.useContext(RiskTemplateAPIContext)

  const isPublic = React.useContext(PublicContext)

  const isRegisters = isRisksRegister || router.query.multiple
  const riskFieldValueItem = risk?.fieldValueMap?.find(({ fieldId }) => fieldId === field.id)

  const onButtonClick = () =>
    showModal({
      field,
      riskId,
      fieldValueId: fieldValueId || riskFieldValueItem?.fieldValueId
    })

  if (isRegisters || !field.historyEnabled || isPublic) {
    return null
  }

  return (
    <Tooltip title='History' placement='bottom'>
      <ClockIconButton onClick={onButtonClick} />
    </Tooltip>
  )
}

export default HistoryButton
